import React from 'react';
import FceContractsPage from '../FceContractsPage';

const FceContracts = () => <FceContractsPage />;

export default FceContracts;
